import { getDashboardJobs } from '../api';
import { dispatchErrorAction } from './index';
import { GET_DASHBOARD_SUCCESS } from './actionTypes';

export function getDashboardJobsAction (startDate, days_to_take) {
  return (dispatch, getState) => {
    const { user } = getState();

    return getDashboardJobs(startDate, days_to_take, user.name)
      .then(({ data }) => dispatch({ type: GET_DASHBOARD_SUCCESS, data }))
      .catch(error => dispatchErrorAction(error, dispatch));
  };
}



// WEBPACK FOOTER //
// ./src/actions/dashboard.js